/*eslint max-lines: ["error", 350]*/

import React from 'react';

import {
  useAdminView,
  ModalV2,
  PrimaryButtonLarge,
  PrimaryButton,
  SecondaryButton,
  SummarySectionV2,
  SummaryFieldV2,
} from '@fingermarkglobal/cringer.components';

import { version } from '../../../package.json';

const CustomAdminView = () => {
  const {
    serial,
    menuOrganisationId,
    menuStoreId,
    orderOrganisationId,
    orderStoreId,
    env,
    paymentIpAddress,
    paymentUsbPid,
    paymentUsbPort,
    paymentUsbVid,
    provider,
    siteId,
    timezone,
    manualLock,
    exit,
    t,
    reboot,
    paymentPoiId,
    orderMock,
    paymentMock,
    openModal,
    closeModal,
    isOpenModal,
    openTransactions,
    lockScreens,
    formatPrice,
    labs,
  } = useAdminView();

  return (
    <div data-test="admin-view" className="admin-view">
      <h1 className="admin-view_title">{t('adminTitle')}</h1>

      <div className="admin-view_sections">
        <SummarySectionV2 title={t('adminGeneralSection')}>
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminSerialKeyField')}
            text={serial}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminVersionField')}
            text={version}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminEnvironmentField')}
            text={env}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminTimezoneField')}
            text={timezone}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminSiteField')}
            text={siteId}
          />
        </SummarySectionV2>

        <SummarySectionV2 title={t('adminMenuSection')}>
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminOrganisationField')}
            text={menuOrganisationId}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminStoreField')}
            text={menuStoreId}
          />
        </SummarySectionV2>

        <SummarySectionV2 title={t('adminOrderingSection')}>
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminOrganisationField')}
            text={orderOrganisationId}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminStoreField')}
            text={orderStoreId}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminMockField')}
            text={orderMock ? t('adminMockFieldTrueText') : t('adminMockFieldFalseText')}
          />
        </SummarySectionV2>

        <SummarySectionV2 title={t('adminPaymentSection')}>
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminProviderField')}
            text={provider}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminMockField')}
            text={paymentMock ? t('adminMockFieldTrueText') : t('adminMockFieldFalseText')}
          />
          <SummaryFieldV2
            className="admin-view_sections_fields"
            title={t('adminPaymentPoiIdField')}
            text={paymentPoiId}
          />
          {paymentIpAddress && (
            <SummaryFieldV2
              className="admin-view_sections_fields"
              title={t('adminPaymentIpAddressField')}
              text={paymentIpAddress}
            />
          )}
          {paymentUsbPid && (
            <SummaryFieldV2
              className="admin-view_sections_fields"
              title={t('adminPaymentUsbPidField')}
              text={paymentUsbPid}
            />
          )}
          {paymentUsbVid && (
            <SummaryFieldV2
              className="admin-view_sections_fields"
              title={t('adminPaymentUsbVidField')}
              text={paymentUsbVid}
            />
          )}
          {paymentUsbPort && (
            <SummaryFieldV2
              className="admin-view_sections_fields"
              title={t('adminPaymentUsbPortField')}
              text={paymentUsbPort}
            />
          )}
        </SummarySectionV2>

        {process.env.POI_APP_ENV === 'sbx' && labs && (
          <SummarySectionV2 title="Labs">
            {labs.customRestaurantEndpoint && (
              <SummaryFieldV2
                title="Custom Restaurant Endpoint"
                text={labs.customRestaurantEndpoint}
              />
            )}

            {labs.customSaveOrderEndpoint && (
              <SummaryFieldV2
                title="Custom Save Order Endpoint"
                text={labs.customSaveOrderEndpoint}
              />
            )}

            {labs.customPreOrderEndpoint && (
              <SummaryFieldV2
                title="Custom Pre Order Endpoint"
                text={labs.customPreOrderEndpoint}
              />
            )}

            {labs.customPlaceOrderEndpoint && (
              <SummaryFieldV2
                title="Custom Place Order Endpoint"
                text={labs.customPlaceOrderEndpoint}
              />
            )}

            {labs.customCancelOrderEndpoint && (
              <SummaryFieldV2
                title="Custom Cancel Order Endpoint"
                text={labs.customCancelOrderEndpoint}
              />
            )}
          </SummarySectionV2>
        )}
      </div>

      <div className="admin-view_sections_buttons-wrapper" data-test="admin-view-footer">
        <div className="admin-view_sections_buttons-wrapper_container">
          <PrimaryButton
            data-test="admin-view-footer-lock-button"
            className="admin-view_sections_buttons-wrapper_button"
            onClick={openModal}
          >
            {t('adminLockModal')}
          </PrimaryButton>
          <PrimaryButton
            className="admin-view_sections_buttons-wrapper_button"
            data-test="admin-view-footer-refresh-button"
            onClick={reboot}
          >
            {t('adminRefreshAction')}
          </PrimaryButton>
          <PrimaryButton
            className="admin-view_sections_buttons-wrapper_button"
            data-test="admin-view-footer-transactions-button"
            onClick={openTransactions}
          >
            {t('adminTransactionsAction')}
          </PrimaryButton>
        </div>
        <SecondaryButton
          className="admin-view_sections_buttons-wrapper_button"
          data-test="admin-view-footer-exit-button"
          onClick={exit}
        >
          {t('adminExitAction')}
        </SecondaryButton>
      </div>

      {isOpenModal && (
        <ModalV2
          closeModal={closeModal}
          closeText={t('adminLockModalClose')}
          open={isOpenModal}
          title={t('adminLockModalTitle')}
          data-test="admin-lock-modal"
          formatPrice={formatPrice}
        >
          <div className="admin-view_sections_lock-wrapper">
            {lockScreens.map(({ name, message }, index) => (
              <PrimaryButtonLarge
                key={index}
                data-test={`admin-view-lock-modal-option-${index}`}
                onClick={manualLock(message)}
              >
                <p className="admin-view_sections_lock-wrapper_texts">{name}</p>
                <p className="admin-view_sections_lock-wrapper_message">{message}</p>
              </PrimaryButtonLarge>
            ))}
          </div>
        </ModalV2>
      )}
    </div>
  );
};

export { CustomAdminView };
